export enum DatabaseDocumentType {
    recordIndex = 0,
    documentContents = 1
}
